import React, { ReactElement } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import styles from './LoadingIndicator.css';

const useStyles = makeStyles({
  root: {
    color: 'var(--orange-04)',
  },
});

const LoadingIndicator = (): ReactElement => {
  const classes = useStyles();
  return (
    <div className={styles.container}>
      <CircularProgress classes={{ root: classes.root }} />
    </div>
  );
};

export default LoadingIndicator;
